import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "frame-37" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "frame-38" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-wrapper-20" }, "Fidélité client renforcée"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-wrapper-21" }, " Mettez en place des programmes de fidélité personnalisés pour transformer vos clients en ambassadeurs. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['container-2', `property-1-${_ctx.property1}`, _ctx.className])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "handshake",
        alt: "Handshake",
        src: _ctx.handshake
      }, null, 8, _hoisted_2),
      _hoisted_3
    ])
  ], 2))
}